module.exports = __webpack_public_path__ + "media/images/twitter_logo_bird-863226e1c03cb268a6e8771d20a0b91f.png";